<script setup>
import {computed} from 'vue'
import {useRouter} from 'vue-router'
import {useComponentFieldsStore} from '@/stores/componentFields'
import Button from '@/common/Button.vue'

const router = useRouter()
const componentFieldsStore = useComponentFieldsStore()

// --- Computed ---

const activeEditId = computed(() => componentFieldsStore.activeEditId)

const isContentTypeComponent = computed(() => {
    return componentFieldsStore.isContentType
})

// --- Methods ---

const doShowAddFieldForm = () => {
    // Relates to when editing a content type's fields in Themes -> Content types
    if (isContentTypeComponent.value) {
        componentFieldsStore.activeEditId = 0
    } else {
        router.push({
            name: 'componentFields',
            params: {
                fieldsetId: componentFieldsStore.activeFieldsetId || 0,
                fieldId: 0
            }
        })
    }
}
</script>

<template>
    <Button
        class="border"
        title="Add a field"
        @click="doShowAddFieldForm"
        :active-class="'btn-primary'"
        :active-value="activeEditId === 0"
    >
        <i class="bi bi-plus-lg"/>
        Field
    </Button>
</template>